<template lang="pug">
.social-links
	button.social-links__link.social-links__link--email(@click="goToEmailForm()", type="button")
		i.fas.fa-mobile-alt
		p Email
	button.social-links__link.social-links__link--facebook(@click="share('facebook')", type="button")
		i.fab.fa-facebook-f
		p Facebook
	button.social-links__link.social-links__link--twitter(@click="share('twitter')", type="button")
		i.fab.fa-twitter
		p Twitter
	button.social-links__link.social-links__link--linkedin(@click="share('linkedin')", type="button")
		i.fab.fa-linkedin-in
		p LinkedIn
</template>

<script>
import axios from 'axios';

export default {
	name: 'SocialLinks',
	props: ['data', 'config'],
	components: {
	},
	data() {
		return {
			width: 600,
			height: 500,
			urlParams: {
				text: '',
				url: '',
			},
		};
	},
	mounted() {
	},
	computed: {
		facebookUrl() {
			return `https://www.facebook.com/sharer/sharer.php?u=${this.urlParams.url}&quote=${this.urlParams.text}`;
		},
		twitterUrl() {
			return `https://twitter.com/intent/tweet?text=${this.urlParams.text}&url=${this.urlParams.url}`;
		},
		linkedinUrl() {
			return `https://www.linkedin.com/sharing/share-offsite/?url=${this.urlParams.url}`;
		}
	},
	methods: {
		goToEmailForm() {
			if (this.data.email === '' || !this.validateEmail(this.data.email)) {
				this.$emit('invalidEmail')
			} else {
				this.$emit('goToPage', 'email-form');
			}
		},
		share(type) {
			var typeUrl = this[`${type}Url`];

			console.log("Share: " + type + " -> " + typeUrl);

			if (this.data.email === '') {
				this.$emit('invalidEmail')
			} else {

				console.log("POST: " + this.config.getItemApi + " : " + JSON.stringify(this.data));

				axios.post(this.config.getItemApi, this.data)
					.then(res => {

						console.log("RESPONSE: " + JSON.stringify(res.data));

						if (res.data.success) {
							console.log("CONFIG: " + JSON.stringify(this.config));
							
							this.urlParams.text = encodeURIComponent(this.config.shareText);
							this.urlParams.url = this.config.refereePageUrl + '?m=' + res.data.userGuid + '&source=' + type;

							console.log("URL: " + this.urlParams.url);

							this.urlParams.url = encodeURIComponent(this.urlParams.url);

							window.open(
								this[`${type}Url`],
								'targetWindow',
								`toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${this.width},height=${this.height}`
							);
							this.$emit('goToPage', 'thank-you');

						} else {
							console.error('There was an error!');
						}
					})
					.catch(err => {
						console.error('There was an error!', err);
					})
				
			}
		},
		validateEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		}
	}
}
</script>

<style lang="scss">
.social-links {
	display: grid;
	grid-auto-columns: 1fr;
	grid-auto-rows: 1fr;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	gap: 1rem 1rem;
	width: 100%;
	height: 100%;
	&__link {
		cursor: pointer;
		height: 48px;
		border-radius: 10px;
		border: 0;
		display: flex;
		justify-content: center;
		color: #ffffff;
		transition: 0.45s ease;
		z-index: 1;
		position: relative;
		display: flex;
		overflow: hidden;
		align-items: center;
		justify-content: center;
		&:hover {
			text-decoration: none;
			color: #fff;
			&:after {
				transform: skewX(-20deg) scale(1, 1);
			}
		}
		&:after {
			position: absolute;
			z-index: -1;
			top: 0;
			right: 0;
			bottom: 0;
			left: -10px;
			width: calc(100% + 20px);
			content: '';
			transition: 0.45s ease;
			transform: skewX(-20deg) scale(0, 1);
			transform-origin: left;
			background: #3d505a;
		}
		i {
			line-height: 46px;
		}
		p {
			padding-left: .5rem;
			padding-top: 5px;
			margin: 0;
		}
		&:focus{
			outline: none;
		}
		&:focus-visible{
    		outline: 5px auto -webkit-focus-ring-color;
			text-decoration: none;
			color: #fff;
			&:after {
				transform: skewX(-20deg) scale(1, 1);
			}	
		}
		&--email {
			background: #636667;
			grid-area: 1 / 1 / 2 / 2;
		}
		&--facebook {
			background: #0166E2;
			grid-area: 1 / 2 / 2 / 3
		}
		&--twitter {
			background: #1DA1F2;
			grid-area: 2 / 1 / 3 / 2
		}
		&--linkedin {
			background: #0A66C2;
			grid-area: 2 / 2 / 3 / 3
		}
	}
}
</style>
